// v10/src/services/navigationService.js
// Cliente para los endpoints de R7 Navegaciones.

import api from './apiService';

export const navigationService = {
  // ── Airports ────────────────────────────────────────────────────

  // GET /api/airports/search?q=X&limit=20
  async searchAirports(q, limit = 20) {
    const res = await api.get('/api/airports/search', { params: { q, limit } });
    return res.data;
  },

  // GET /api/airports/by-icao/:icao
  async getAirportByIcao(icao) {
    const res = await api.get(`/api/airports/by-icao/${encodeURIComponent(icao)}`);
    return res.data;
  },

  // GET /api/airports/nearest?lat=X&lng=Y&radius=R
  async getNearestAirport(lat, lng, radius = 50) {
    const res = await api.get('/api/airports/nearest', { params: { lat, lng, radius } });
    return res.data;
  },

  // ── Navigations ─────────────────────────────────────────────────

  // POST /api/navigations/calculate (no persiste)
  async calculate({ aircraft_id, origin_icao, destination_icao, waypoints, cruise_tas_knots, cruise_consumption_gph, cruise_altitude_ft }) {
    const res = await api.post('/api/navigations/calculate', {
      aircraft_id,
      origin_icao,
      destination_icao,
      waypoints,
      cruise_tas_knots,
      cruise_consumption_gph,
      cruise_altitude_ft,
    });
    return res.data;
  },

  // POST /api/navigations (recalcula + persiste)
  async save(payload) {
    const res = await api.post('/api/navigations', payload);
    return res.data;
  },

  // GET /api/navigations/history
  async history({ aircraft_id, pilot_id, limit } = {}) {
    const params = {};
    if (aircraft_id) params.aircraft_id = aircraft_id;
    if (pilot_id) params.pilot_id = pilot_id;
    if (limit) params.limit = limit;
    const res = await api.get('/api/navigations/history', { params });
    return res.data;
  },

  // GET /api/navigations/:id
  async getById(id) {
    const res = await api.get(`/api/navigations/${id}`);
    return res.data;
  },

  // GET /api/navigations/flight-auths-for-aircraft?aircraft_id=X
  async listFlightAuthsForNav(aircraft_id) {
    const res = await api.get('/api/navigations/flight-auths-for-aircraft', {
      params: { aircraft_id },
    });
    return res.data;
  },
};

export default navigationService;
